/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React from "react";
import queryString from "query-string";
import Helmet from "react-helmet";

import { WithLocalize } from '../../containers/I18nProvider';
import RequestLoginErrorMessage from "../../components/RequestLoginErrorMessage";
import ServiceApi from "../../services/ServiceApi";

import "./style.scss";
import favicon from "./image/favicon.ico";
import logo from "./image/logo.png";
import LoginForm from "./LoginForm";

class Login extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.api = new ServiceApi(this);
    this.parameters = queryString.parse(props.location.search);
    props.changeDefaultLocale('pt-BR');
  }

  _validateParams() {
    if (
      !this.parameters.client_id ||
      !this.parameters.redirect_uri ||
      !this.parameters.response_type
    ) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    document.body.className = "ggnet-body";
    document.title = "GGNet Telecom - Noggin & Paramount+";
  }

  render() {
    const { translate } = this.props;

    return (
      <div>
        <Helmet>
          <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
        </Helmet>
        <div className="container container-ggnet">
          <div className="row">
            <div className="col-lg-6 mx-auto">
              <div
                className="card card-signin my-5"
                style={{ border: "1px solid" }}
              >
                <div className="card-body">
                  <a className="logo-ggnet" href="http://www.gegnet.com.br">
                    <img src={logo} alt="logo-ggnet" />
                  </a>
                  <div>
                    {this._validateParams() ? (
                      <LoginForm
                        api={this.api}
                        location={this.props.location}
                      />
                    ) : (
                      <RequestLoginErrorMessage
                        onlyMessage={true}
                        message={translate("RequestLoginErrorMessage")}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WithLocalize(Login);
